// @flow
import React from 'react'
import styled, { type StyledComponent } from 'styled-components'
import logo from '../images/fb-promo-logo.png'
import type { Media, Crop, Public } from '../../types'
import OptionalResponsibleImage from './OptionalResponsibleImage'
import androidTemplateBackground from '../images/android-template.png'
import closeIcon from '../images/facebook-audience-network-close.png'
import { translations, translateFunc } from '../../../shared/localize'

const Wrapper: StyledComponent<Object, any, any> = styled.div`
  width: 234px;
  height: 494px;
  padding: 46px 11px 42px 15px;
  background: url(${androidTemplateBackground}) no-repeat center center;
  background-size: cover;
  overflow: hidden;
  text-align: center;
  display: flex;
`
const Logo: StyledComponent<Object, any, any> = styled.div`
  margin: 12px auto 0;
  vertical-align: top;
  width: 30px;
  height: 30px;
  background: url(${({ image }: Object) => image || logo});
  background-size: 100% 100%;
`
const Title: StyledComponent<Object, any, any> = styled.div`
  margin-top: 9px;
  color: rgb(75, 79, 86);
  font-size: 10px;
  line-height: 14px;
  word-break: break-word;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: bold;
  height: 35px;
`
const Text: StyledComponent<Object, any, any> = styled.div`
  max-height: 24px;
  margin-top: 30px;
  color: #afafaf;
  font-size: 10px;
  line-height: 12px;
  flex-grow: 1;
  color: #1d2129;
  width: 100%;
`

const Inner: StyledComponent<Object, any, any> = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  background-color: #fff;
`
const Head: StyledComponent<Object, any, any> = styled.div`
  position: relative;
`
const CloseIcon: StyledComponent<Object, any, any> = styled.div`
  background: url(${closeIcon}) no-repeat center center;
  background-size: 100% 100%;
  position: absolute;
  top: 5px;
  right: 5px;
  cursor: pointer;
  z-index: 100;
  width: 20px;
  height: 20px;
`
const Button: StyledComponent<Object, any, any> = styled.button`
  background-color: rgba(86, 144, 255, 1);
  color: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  font-size: 12px;
  height: 28px;
  max-height: 50px;
  text-align: center;
  width: 100%;
  margin: 0 auto;
  border: none;
  margin-bottom: 7px;
`
const Section: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 0 15px;
`
const SectionContent: StyledComponent<Object, any, any> = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  flex-grow: 1;
  padding-top: 25px;
  padding-bottom: 10px;
`

type Props = {|
  title: string,
  description: string,
  image: ?Media,
  imageCrop: ?Crop,
  publicInfo: ?Public,
  linkButton: string
|}

const t = translateFunc(translations.provider_previews.facebook)

export default function FacebookMobile(props: Props) {
  const { title, description, image, imageCrop, publicInfo, linkButton } = props
  return (
    <Wrapper>
      <Inner>
        <Head>
          <OptionalResponsibleImage image={image} imageCrop={imageCrop} width={208} ratio={1.91} />
          <CloseIcon />
        </Head>
        <Section>
          <SectionContent>
            <Title>{publicInfo ? publicInfo.label : 'Название группы'}</Title>
            <Logo image={publicInfo && publicInfo.image_url} />
            <Text>
              <div>{title}</div>
              <div>{description}</div>
            </Text>
          </SectionContent>
          <div>
            <Button>{t(linkButton)}</Button>
          </div>
        </Section>
      </Inner>
    </Wrapper>
  )
}
